import { MY_READINGS_LEGACY_ID_ALIASES } from '../data/jyotishaMyReadingsTopics';

/** Normalize deprecated topic IDs (e.g. renames) for routing and TAB_BY_ID lookup. */
const JYOTISHA_TOPIC_ID_ALIASES = {
  'reading-charts-dharma-trikon': 'reading-charts-power-of-trikonas',
  'reading-charts-nakshatra-pada-naming': 'reading-charts-nakshatra-charan-naming',
  /** Was under Prarambh; canonical lesson lives under राशि (Rashis) as Overview. */
  'rashi-basics': 'rashis-basics',
  ...MY_READINGS_LEGACY_ID_ALIASES,
};

/**
 * @param {string | null | undefined} topicId
 * @returns {string | null | undefined}
 */
export function canonicalJyotishaTopicId(topicId) {
  if (topicId == null) return topicId;
  return JYOTISHA_TOPIC_ID_ALIASES[topicId] ?? topicId;
}
